import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import * as fromMenuItems from './+state/menu-items.reducer'
import { MenuItemsEffects } from './+state/menu-items.effects'
import { MenuItemsFacade } from './+state/menu-items.facade'

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromMenuItems.MENU_ITEMS_FEATURE_KEY, fromMenuItems.menuItemsReducer),
    EffectsModule.forFeature([MenuItemsEffects]),
  ],
  providers: [MenuItemsFacade],
})
export class GbDashboardSetupDataAccessMenuItemsModule {}
